import { IError } from '../../types';
import Gizmo from '../gizmo';
import RootGizmo from '../root-gizmo';

interface IParams {
  gizmo: Gizmo | RootGizmo;
  handler: 'validateHDLR';
  withoutServer?: boolean;
}

/**
 * Run a function on each element of the Gizmo's tree
 *
 * @param {Gizmo | RootGizmo} gizmo the Gizmo whose tree is going to be evaluated
 * @param {string} handler Handler which is going to be executed, right now we've only developed
 * 	the code to run the validations
 * @returns {Promise<any>}
 */
function runHandlerOnGizmosTree({ gizmo, handler, withoutServer }: IParams): Promise<any> {
  return new Promise<any>(async resolve => {
    if (handler === 'validateHDLR') {
      const gizmos = gizmo.getGizmos();
      let errors: IError[] = [];

      // We recolect the gizmo's 'own' errors
      if (!['form', 'view'].includes(gizmo.getConfig().type)) {
        const g = gizmo as Gizmo;
        const gErrors = await g.validate(withoutServer);

        if (gErrors.length > 0) {
          errors = errors.concat(gErrors);
        }
      }

      // Then, in the case the Gizmo has children, we recolect the children errors
      if (gizmos && gizmos.length > 0) {
        for (const g of gizmos) {
          const gErrors: IError[] = await runHandlerOnGizmosTree({
            gizmo: g,
            handler,
            withoutServer,
          });

          if (gErrors.length > 0) {
            errors = errors.concat(gErrors);
          }
        }
      }

      resolve(errors);
    }

    resolve(undefined);
  });
}

export default runHandlerOnGizmosTree;
